(() => {
  window.addEventListener(
    'click',
    (event) => {
      const toggle = event.target.closest('.card-variant-options__toggle');
      if (!toggle) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const options = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!options) return;

      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      options.classList.toggle('card-variant-options--collapsed', expanded);
      toggle.textContent = expanded ? toggle.dataset.count : '−';
      toggle.setAttribute('aria-label', expanded ? toggle.dataset.label : '收合子類');
    },
    true
  );
})();
